import { render, staticRenderFns } from "./AuthorVideoDetail.vue?vue&type=template&id=6c2c1532&scoped=true"
import script from "./AuthorVideoDetail.vue?vue&type=script&lang=js"
export * from "./AuthorVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthorVideoDetail.vue?vue&type=style&index=0&id=6c2c1532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c1532",
  null
  
)

export default component.exports